module.exports = "<ul [innerHTML]=\"render\">\n</ul>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pagination/pagination.component.html
// module id = ./src/app/pagination/pagination.component.html
// module chunks = main